import configureStore from './configureStore'

export const store = configureStore({})

export const useDispatch = () => store.dispatch

export const useSelector = (selector: any) => selector(store.getState())
